export function formatNumber(num){
    if (num >= 1000000000) {
        return (num / 1000000000).toFixed(0) + 'B';
    } else if (num >= 1000000) {
        return (num / 1000000).toLocaleString('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 4 }) + 'M';
    } else if (num >= 1000) {
        return (num / 1000).toLocaleString('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 3 }) + 'K';
    }
    return num;
};